import React, { useState, useEffect } from "react";
import Service from "../../Service/firebase";

const AddWorkDetails = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [vendorCode, setVendorCode] = useState("");
  const [vendorCodeError, setVendorCodeError] = useState("");
  const [formData, setFormData] = useState({
    vendorId: "",
    opening_time: "",
    closing_time: "",
    off_day: "",
  });

  useEffect(() => {
    Service.getAllData("vendors").then((list) => {
      if (list.length > 0) setVendors(list);
    });
  }, []);

  const handleVendorCodeBlur = () => {
    if (vendorCode) {
      const found = vendors.find((v) => v.vendorCode === vendorCode);
      if (found) {
        setFormData((prev) => ({ ...prev, vendorId: found.uid }));
        setVendorCodeError("");
      } else {
        setFormData((prev) => ({ ...prev, vendorId: "" }));
        setVendorCodeError("Vendor code not found");
      }
    }
  };

  const onEdit = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.vendorId) {
      setVendorCodeError("Please enter a valid vendor code");
      return;
    }
    setIsLoading(true);
    const res = await Service.addData(formData, "workDetails", "workDetailsId");
    if (res === "success") {
      const vendor = vendors.find((v) => v.uid === formData.vendorId);
      if (vendor && !vendor.workDetails) {
        await Service.updateData({ workDetails: true }, "vendors", vendor.uid);
      }
      setIsLoading(false);
      props.handleSuccessDailog();
    } else {
      setIsLoading(false);
      props.handleErrorDailog();
    }
  };

  return isLoading ? (
    <div style={{ textAlign: "center", padding: 40 }}>
      <i className="fas fa-spinner fa-pulse fa-2x"></i>
    </div>
  ) : (
    <div style={{ padding: "16px" }}>
      <form onSubmit={handleSubmit}>
        {/* Vendor Code */}
        <div className="form-group">
          <label>Vendor Code <span style={{ color: "red" }}>*</span></label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter vendor code"
            value={vendorCode}
            onChange={(e) => setVendorCode(e.target.value)}
            onBlur={handleVendorCodeBlur}
            required
          />
          {vendorCodeError && <small style={{ color: "red" }}>{vendorCodeError}</small>}
          {formData.vendorId && !vendorCodeError && (
            <small style={{ color: "green" }}>
              {vendors.find((v) => v.uid === formData.vendorId)?.salonName || "Vendor found"}
            </small>
          )}
        </div>

        {/* Opening Time */}
        <div className="form-group">
          <label>Opening Time <span style={{ color: "red" }}>*</span></label>
          <input
            name="opening_time"
            type="time"
            className="form-control"
            value={formData.opening_time}
            onChange={onEdit}
            required
          />
        </div>

        {/* Closing Time */}
        <div className="form-group">
          <label>Closing Time <span style={{ color: "red" }}>*</span></label>
          <input
            name="closing_time"
            type="time"
            className="form-control"
            value={formData.closing_time}
            onChange={onEdit}
            required
          />
        </div>

        {/* Off Day */}
        <div className="form-group">
          <label>Off Day <span style={{ color: "red" }}>*</span></label>
          <select
            name="off_day"
            className="form-control"
            value={formData.off_day}
            onChange={onEdit}
            required
          >
            <option value="">Select Off Day</option>
            <option value="No Off Day">No Off Day</option>
            <option value="Monday">Monday</option>
            <option value="Tuesday">Tuesday</option>
            <option value="Wednesday">Wednesday</option>
            <option value="Thursday">Thursday</option>
            <option value="Friday">Friday</option>
            <option value="Saturday">Saturday</option>
            <option value="Sunday">Sunday</option>
          </select>
        </div>

        <div className="d-flex" style={{ gap: 8 }}>
          <button type="submit" className="btn btn-primary">Save</button>
          <button type="button" className="btn btn-secondary" onClick={props.handleErrorDailog}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddWorkDetails;
